import { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import {
  RecommendedUsers,
  HomeSearch,
  ShareModal,
  PageLoader,
  Details,
} from '../components';
import AppContext from '../context/AppContext';

import { pageAnimation } from '../animation';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import useApi from '../hooks/useApi';
import postApi from '../api/post';
export default function PostDetails() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [share, setShare] = useState(false);

  const { currentAccount, theme, isLoggedIn, isMember, hasLoaded } =
    useContext(AppContext);
  const getPostDetails = useApi(postApi.getPublication);
  const getComments = useApi(postApi.getPublications);
  const location = useLocation();
  const pathname = location.pathname;
  const postId = pathname.split('/')[3];

  useEffect(() => {
    if (hasLoaded) {
      if (!isLoggedIn) {
        navigate('/connect');
      } else if (!isMember) {
        navigate('/create-profile');
      } else {
      }
    }
  }, [isMember, isLoggedIn, hasLoaded]);

  useEffect(() => {
    getPostDetails.request(postId);
    getComments.request({
      commentsOf: `${postId}`,
      // also dont forget you can filter these queries on sources as well
      // "sources": ["lost-place-dapp"]
    });
  }, []);
  console.log('POST DETAILS HERE', getPostDetails.data?.publication);
  const postDetails = getPostDetails.data?.publication;
  const comments = getComments.data?.publications?.items;
  console.log('COMMENTS OF PUBLICATION', comments);
  return (
    <StyledPostDetails
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      theme_={theme}
    >
      {!postDetails || !comments ? (
        <PageLoader visible={true} />
      ) : (
        <>
          <div className="left">
            <div className="header">
              <span
                onClick={() => navigate(`${location?.state?.path || '/'}`)}
                className="back"
              >
                <KeyboardBackspaceIcon />
              </span>
              <span>
                <h2>Post details</h2>
              </span>
            </div>

            <div className="post">
              <Details
                post={postDetails}
                comments={comments}
                setShare={setShare}
              />
            </div>
          </div>
          <div className="right">
            <HomeSearch />
            <RecommendedUsers />
            <ShareModal
              show={share}
              onClose={() => setShare(false)}
              theme_={theme}
            />
          </div>
        </>
      )}
    </StyledPostDetails>
  );
}
const StyledPostDetails = styled(motion.div)`
  display: flex;
  flex-flow: row wrap;
  position: fixed;
  width: 80%;
  right: 0;
  top: 0;
  height: 100%;
  overflow-y: scroll;
  @media screen and (max-width: 900px) {
    position: absolute;
    width: 100%;
    padding-bottom: 15%;
  }
  .left {
    width: 60%;
    display: flex;
    flex-flow: column wrap;
    -moz-box-shadow: 0 0 3px #ccc;
    -webkit-box-shadow: 0 0 3px #ccc;
    box-shadow: 0 0 3px #ccc;
    clip-path: inset(0px -15px 0px 0px);
    @media screen and (max-width: 900px) {
      width: 100%;
    }
    .header {
      display: flex;
      gap: 1rem;
      align-items: center;
      position: sticky;
      top: 0;
      padding: 1rem 2rem;
      background: ${({ theme_ }) =>
        theme_ ? 'rgb(15, 15, 15,0.8)' : 'rgb(255, 255, 255,0.8)'};
      z-index: 2;
      @media screen and (max-width: 900px) {
        display: flex;
        gap: 1rem;
        align-items: center;
        padding: 0.8rem 1rem;
      }
    }
    .back {
      cursor: pointer;
    }
  }
  .right {
    width: 40%;
    padding: 0rem 1rem;
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    position: sticky;
    top: 0;
    right: 0;
    @media screen and (max-width: 900px) {
      display: none;
    }
  }
  .post {
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    padding: 1rem 1rem;
    @media screen and (max-width: 900px) {
      gap: 0rem;
      padding: 0rem 0rem;
    }
  }
`;
